@if(config.showCompanyStatus){
    <div class="dialog-static-header" fxLayout="row" fxLayoutAlign="space-between center">
        <span fxFlex="200px"></span>
        <h1 class="mat-headline-4" style="margin-bottom: 10px; margin-top:10px;">{{config.title}}</h1>
        <span fxFlex="200px">
            <span style="font-weight: 400; font-size: 10px;">
                <span fxLayout="row" title="Year-end date">
                    <span fxFlex="65px" fxAlign="end">Year-end:</span>
                    <span fxFlex>{{financialYearEnd | companyDate: region}}</span>
                </span>
                <span fxLayout="row" title="Next period-end processing date">
                    <span fxFlex="65px" fxAlign="end">Period-end:</span>
                    <span fxFlex>{{nextProcessingDate | companyDate: region}}</span>
                </span>
            </span>
        </span>
    </div>
}
@else{
    <div class="dialog-static-header" fxLayout="row" fxLayoutAlign="center center">
        <h1 class="mat-headline-4" style="margin-bottom: 10px; margin-top:10px;">{{config.title}}</h1>
    </div>
}
<div class="dialog-container">
    <app-group-edit-container [config]="config" [dialogRef]="dialogRef"></app-group-edit-container>
</div>
<div class="dialog-static-footer" fxLayout="row" fxLayoutAlign="center center">
    <app-edit-view-actions [completeText]="config.actionText ? config.actionText : 'Save'"
        [cancelText]="'Close'"
        [hideCancelButton]="config.hideCancelButton"
        (completed)="completedModalAction()"
        (cancelled)="cancelledModalEdit()"
        (debug)="debugModalData()"
        [disabled]="!config.form.valid || completeDisabled">
    </app-edit-view-actions>
</div>    